var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPhone = function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#1F4970",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M2.25 3.75a1.5 1.5 0 0 1 1.5-1.5h2.46a.75.75 0 0 1 .71.513l1.124 3.37a.75.75 0 0 1-.376.908l-1.693.846a8.28 8.28 0 0 0 4.138 4.138l.846-1.693a.75.75 0 0 1 .908-.376l3.37 1.123a.75.75 0 0 1 .513.712v2.459a1.5 1.5 0 0 1-1.5 1.5h-.75c-6.213 0-11.25-5.037-11.25-11.25z"
  })));
};
export default SvgPhone;